import { useTranscriptionsState } from '@modules/transcriptions/useTranscriptionsState';
import { Stack, Tooltip, Typography } from '@mui/material';
import { Note } from 'src/@types/notes-transcription';
import { Iconify } from 'src/components/iconify';
import { useActionBarState } from 'src/features/ActionsBar/useActionBarState';
import { SessionItemHeader } from 'src/features/GatheringSessions/styles';
import { useLocales } from 'src/locales';
import { FormatTime } from 'src/utils/formatTime';
import { SessionItemContent, SessionMenuItem, StyledNoteItem } from './styles';

interface IProps {
  note: Note;
  channelId: string;
  handleClose: () => void;
}

export const PastNotesItem = ({ note, handleClose }: IProps) => {
  const { translate } = useLocales();

  const { openNote } = useTranscriptionsState();
  const { setOpenAction } = useActionBarState();

  const handleOpenNote = () => {
    openNote(note);
    setOpenAction('notes');
    handleClose();
  };

  return (
    <SessionMenuItem key={note._id} onClick={handleOpenNote}>
      <SessionItemHeader>
        <Stack direction="row" justifyContent="space-between" gap={3}>
          <Stack>
            <Stack direction="row" alignItems="center" gap={1}>
              <Iconify icon="tabler:calendar-stats" color="text.secondary" />
              <Typography variant="subtitle1">
                {FormatTime.Date(note.createdAt, 'PPPP')}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={1} ml={3} pl={0.5}>
              <Typography variant="caption" color="text.secondary">
                {translate('communicate.past_sessions.session_time', {
                  sessionTime: FormatTime.Date(note.createdAt, 'p'),
                })}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </SessionItemHeader>

      <SessionItemContent>
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="subtitle2" color="text.secondary">
            {translate('communicate.transcriptions')}
          </Typography>
        </Stack>

        <StyledNoteItem>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <Iconify icon="tabler:file-text" color="primary.main" />
            <Typography variant="subtitle2">{note.title}</Typography>
          </Stack>
          {!note.noteRef && (
            <Tooltip title={translate('communicate.transcriptions.empty')}>
              <Iconify
                icon="tabler:alert-triangle"
                color="error.main"
                width={16}
              />
            </Tooltip>
          )}
        </StyledNoteItem>
      </SessionItemContent>
    </SessionMenuItem>
  );
};
